"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BcTransactionAbstract = void 0;
exports.transactionFactory = transactionFactory;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _ethFuncs = require("./ethereum/ethFuncs");
var _uiFuncs = require("./ethereum/uiFuncs");
function roundCent(strAmount) {
  return Math.round(100 * parseFloat(strAmount));
}
function typeConv(label) {
  if (label.endsWith('Address')) {
    return function (a) {
      return (0, _ethFuncs.padLeft)((0, _ethFuncs.getNakedAddress)(a), 64);
    };
  }
  if (label === 'int') {
    return function (nb) {
      return (0, _ethFuncs.encodeNumber)(parseInt(nb, 19));
    };
  }
  if (label.startsWith('limit') || label === 'amount') {
    return function (nb) {
      return (0, _ethFuncs.encodeNumber)(roundCent(nb));
    };
  }
  if (label.endsWith('Status') || label.endsWith('Type') || label.endsWith('Int')) {
    return function (nb) {
      return (0, _ethFuncs.encodeNumber)(nb);
    };
  }
  if (label.endsWith('Hex')) {
    return function (s) {
      return s.padEnd(128, '0');
    };
  }
  if (label === 'status') {
    return function (nb) {
      return (0, _ethFuncs.encodeNumber)(parseInt(nb, 10) === 0 ? 0 : 1);
    };
  }
  throw new Error("Unexpected label '".concat(label, "' in FnDefs."));
}
var BcTransactionAbstract = /*#__PURE__*/function () {
  function BcTransactionAbstract() {
    (0, _classCallCheck2["default"])(this, BcTransactionAbstract);
  }
  (0, _createClass2["default"])(BcTransactionAbstract, [{
    key: "getSplitting",
    value:
    // //////////////////////////////////////////////////////////////////////////
    //  CM VS Nant Handling
    function getSplitting(nantVal, cmVal, cmMinusLim, amount) {
      cmVal = parseFloat(cmVal);
      nantVal = parseFloat(nantVal);
      var nant = 0;
      var cm = 0;
      var res = parseFloat(amount);
      if (cmVal > 0) {
        if (cmVal >= res) {
          cm = res;
          res = 0;
        } else {
          cm = cmVal;
          res = res - cmVal;
          cmVal = 0;
        }
      }
      if (nantVal > 0) {
        if (nantVal >= res) {
          nant = res;
          res = 0;
        } else {
          nant = nantVal;
          res = res - nantVal;
          // nantVal=0;
        }
      }

      if (res > 0 && cmVal - parseFloat(cmMinusLim) >= res) {
        cm = cm + res;
        res = 0;
      }
      var possible = res === 0;
      return {
        possible: possible,
        nant: nant,
        cm: cm
      };
    }
  }]);
  return BcTransactionAbstract;
}();
exports.BcTransactionAbstract = BcTransactionAbstract;
function transactionFactory(transactionDefs, bcTransactionClass) {
  transactionDefs.forEach(function (contractFnDefs, contractNb) {
    var _loop = function _loop() {
      var _contractFnDefs$fnNam = contractFnDefs[fnName].split(':'),
        _contractFnDefs$fnNam2 = (0, _slicedToArray2["default"])(_contractFnDefs$fnNam, 2),
        fnHash = _contractFnDefs$fnNam2[0],
        argStringList = _contractFnDefs$fnNam2[1];
      var argList = argStringList.split(' ');
      var hasAdditionalPostData = false;
      var hasDelegate = false;
      if (argList.slice(-1)[0] === '*') {
        hasAdditionalPostData = true;
        argList.pop();
      } else if (argList.slice(-1)[0] === 'D') {
        hasAdditionalPostData = true;
        hasDelegate = true;
        argList.pop();
      }
      // Build argument array function
      var argFnList = argList.map(function (arg) {
        return typeConv(arg);
      });
      var concatArgs = function concatArgs(args) {
        return args.map(function (arg, idx) {
          return argFnList[idx](arg);
        }).join('');
      };
      bcTransactionClass.prototype[fnName] = /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(wallet) {
          var addr,
            data,
            _len,
            args,
            _key,
            additionalPostData,
            rawSignedTx,
            _args = arguments;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                addr = wallet.getAddressString();
                _context.next = 3;
                return this.ajaxReq.getTransactionData(addr);
              case 3:
                data = _context.sent;
                if (!data.error) {
                  _context.next = 7;
                  break;
                }
                console.log("Failed getTransactionData(".concat(addr, ")"));
                throw new Error(data.msg);
              case 7:
                for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = _args[_key];
                }
                additionalPostData = hasAdditionalPostData ? args.pop() : {};
                if (hasDelegate) {
                  additionalPostData.delegate = wallet.getAddressString();
                }
                rawSignedTx = (0, _uiFuncs.generateTx)({
                  gasLimit: 500000,
                  data: fnHash + concatArgs(args),
                  to: this.contracts[contractNb],
                  unit: 'ether',
                  value: 0,
                  nonce: 1,
                  gasPrice: null,
                  donate: false,
                  from: addr,
                  key: wallet.getPrivateKeyString()
                }, data);
                return _context.abrupt("return", this.ajaxReq.sendTx(rawSignedTx, additionalPostData));
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    };
    for (var fnName in contractFnDefs) {
      _loop();
    }
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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